import MojitoCore from 'mojito/core';
import AbstractTask from 'services/common/task-runner/abstract-task.js';
import { noop, chunk } from 'mojito/utils';

const { TaskExecutor } = MojitoCore.Services;

/**
 * Retrieves cash out offers for provided <code>betInfos</code>.
 *
 * @class PollCashoutOffersTask
 * @memberof Mojito.Services.Bets.Task
 */
export default class PollCashoutOffersTask extends AbstractTask {
    constructor(config = {}, chunkSuccess = noop, chunkFail = noop) {
        super();
        const { service, betInfos, maxBetsPerRequest = 10 } = config;
        this.cashoutService = service;
        this.betInfos = betInfos;
        this.maxBetsPerRequest = maxBetsPerRequest;
        this.chunkSuccess = chunkSuccess;
        this.chunkFail = chunkFail;
        this.finishCallback = undefined;

        const taskExecutor = new TaskExecutor(() => {
            this.finishCallback && this.finishCallback();
        });
        this.getCashoutOffers = taskExecutor.withQueue(this.getCashoutOffers.bind(this));
    }

    execute(callback) {
        this.finishCallback = callback;
        const chunks = this.buildChunks(this.betInfos, this.maxBetsPerRequest);
        chunks.forEach(betInfosChunk => this.getCashoutOffers(betInfosChunk));
    }

    getCashoutOffers(betInfos) {
        return this.cashoutService
            .getCashoutOffers(betInfos)
            .then(this.chunkSuccess)
            .catch(this.chunkFail);
    }

    buildChunks(betInfos, maxBetsToRequest) {
        const shouldRequestInOneChunk = this.maxBetsPerRequest === 0;
        return shouldRequestInOneChunk ? [betInfos] : chunk(betInfos, maxBetsToRequest);
    }
}
